import { useEffect } from 'react';
import mark from '../mark';
const useMarkOnMount = (marker, metricsAdditionalDimensions, skipMetrics) => {
  useEffect(() => {
    mark(marker, metricsAdditionalDimensions, skipMetrics);
  }, [marker, metricsAdditionalDimensions, skipMetrics]);
};
export default useMarkOnMount;